import reducer from './reducer';

export default reducer;
export {
  FundsState,
  FundsStatus,
  Withdrawal,
  WithdrawalStatus,
} from './reducer';
export { getFundsData, closeWithdrawalSuccessfulAlert } from './actions';



// WEBPACK FOOTER //
// ./src/redux/modules/funds/index.ts